import React from 'react';
import { useEffect, useState, useRef } from "react";
import NavButton from '../../homepage/header-banner/TopNavButton';
import styled from 'styled-components';
import Footer from '../../homepage/footer/Footer'
import Cloudconsult from '../../homepage/consult/cloudconsult';
import Banner from '../../container/Banner/Banner';
import {
    Container, Row, Col
} from 'react-bootstrap';
import { Box, Typography } from '@mui/material';
import '../../microservice/container/sidebar.css';
import '../../Style/defaultstyle.css'
import '../../Style/defaultstyle.scss'
import CommonTable from '../../container/Table/Components/CommonTable';
import CardTable from '../../microservice/components/CardTable';
import Titlecloudcompute from "../../container/Card/Components/Titlecloudcompute"
import config from '../../microservice/components/config-vn';
import Sidebar from '../../container/Sidebar/Sidebar';

// add
import { Grid } from '@mui/material';
import CardBox from '../../container/Box/Components/CardBox';
import CloudConsultCp from '../../homepage/consult/cloudconsult-cp';
import '../../Style/typo.css'
import Cloudconsult2 from '../../homepage/consult/cloudconsult-2';
import BanneServerApplication from '../../container/Banner/banner-serverApplication';
import DividerComponent from '../../container/Divider/divider';
import useIsMobile from '../../container/Sidebar/useIsMobile';
import BannerPrivateCloud from '../../container/Banner/banner-privateCloud';
import BannerPrivateCloudVN from '../../container/Banner/banner-privateCloud-vn';
import SidebarVN from '../../container/Sidebar/Sidebar-vn';
import HeaderVn from '../../detailpageVN/Page/component/headervn';
import FooterVn from '../../detailpageVN/Page/component/footervn';
const Sysfont = styled.div`
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
`;

// Titlecloudcompute
function IaamVN() {
    const isMobile = useIsMobile();
    useEffect(() => {
        document.title = 'Identity And Access Management - Serverless Application - Private Cloud';
    }, []);
    return (
        <Sysfont className='App'>
            <HeaderVn />
            <BannerPrivateCloudVN />
            <Container className="main-body">
                <Row>
                    <Col md={12} lg={3}>
                        {!isMobile && <SidebarVN />}
                    </Col>
                    <Col md={12} lg={9} className="right-content">
                        {/* {Titlecloudcompute("Identity and Access Management")} */}

                        {CardTable("<p class='typo-21 typo-medium typo-black'>Khái niệm</p>", config.tb2_header, config.tb2_content)}
                        <DividerComponent />
                        <BoxContent>
                            <Box sx={TitleWrap}><Typography className="sub-title normal" sx={CardTitle}><p class="typo-21 typo-medium typo-black">OIDC/Oauth</p></Typography></Box>
                            <BoxText >
                                <p class="typo-14">• OIDC (Open ID Connect): để xác thực, lấy ID Token chứa thông tin nhận dạng của người dùng. </p>
                                <p class="typo-14">• OAuth : </p>
                                <p class="typo-14">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delegated Authorization (Ủy quyền ủy thác)</p>
                                <p class="typo-14">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Quy trình xác nhận quyền truy cập tới máy chủ tài nguyên. </p>
                                <p class="typo-14">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Lấy Access Token để truy cập tài nguyên từ máy chủ tài nguyên.</p>
                            </BoxText>
                            <Grid container spacing={1}>
                                <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/msa3-1.png"></ImageWrap>

                                <Grid item xs={12} sm={12}>{CardBox(
                                    "",
                                    `<p class='typo-14'>Ví dụ) </p>
                                    <p class='typo-14'>Trong ứng dụng của công ty (1) đến (9), người dùng đăng nhập bằng tài khoản Facebook của họ.</p>
                                    <p class='typo-14'>Trong ứng dụng của công ty, cho phép người dùng viết bài lên nguồn cấp tin tức (tài nguyên) với quyền Facebook của họ (A) đến (D).
                                    </p></br>
                                    <p class='typo-14'>Các quyền ủy thác và phương pháp </p>
                                    <p class='typo-14'>1. Người dùng truyền ID/PW Facebook của họ vào ứng dụng của công ty (không được sử dụng để bảo mật). </p>
                                    <p class='typo-14'>2. Sử dụng OAuth (an toàn vì ứng dụng của tôi không biết ID, PW của người dùng). </p>`
                                )}
                                </Grid>
                            </Grid>
                            <BoxContent>
                                <BoxTitleIaam className='sub-title'><p class="typo-21 typo-medium typo-black">Tạo token và quyền truy cập</p></BoxTitleIaam>
                                <CommonTable header={config.tb3_header} content={config.tb3_content} />
                            </BoxContent>
                        </BoxContent>


                        <DividerComponent />
                        <BoxContent>
                            <Box sx={TitleWrap}><Typography className="sub-title normal" sx={CardTitle}><p class="typo-21 typo-medium typo-black">Hướng dẫn sử dụng IAM</p></Typography></Box>

                            <ImageWrap src="https://hanbiro.com/assets/images/cloud/en/msa3-2.png"></ImageWrap>
                            <SmallBox>
                                <BoxDetail ><p class="typo-14">Role là tập hợp các quyền cho phép tạo/sửa/xóa/chia sẻ/xem (liệt kê/xem).</p></BoxDetail>
                            </SmallBox>
                            <SmallBox>
                                <BoxDetail >
                                    <p class="typo-14">- Tên Role mặc định -- Ví dụ) Role Name (Quyền hành động)</p>
                                    <p class="typo-14">- Owner: Có toàn quyền.</p>
                                    <p class="typo-14">- Admin: Có tất cả quyền, trừ quyền xóa.</p>
                                    <p class="typo-14">- Editor: Có quyền tạo, xóa, cập nhật, xem và liệt kê.</p>
                                    <p class="typo-14">- Viewer: Chỉ có quyền xem và liệt kê.</p>
                                    <p class="typo-14">- OnlyListingUser: Chỉ được liệt kê tài nguyên (không được xem nội dung).</p>
                                </BoxDetail>
                            </SmallBox>
                            <SmallBox>
                                <BoxDetail >
                                    <p class="typo-14">Ví dụ)</p>
                                    <p class="typo-14">Tài nguyên - FileA</p>
                                    <p class="typo-14">User A là người tạo ra FileA, nên được cấp quyền Owner (Toàn quyền).</p>
                                    <p class="typo-14">User B được phân quyền Editor (có thể tạo, xóa, cập nhật, xem).</p>
                                    <p class="typo-14">Nhóm C chỉ được cấp quyền Viewer, để có thể thấy và xem FileA.</p>
                                </BoxDetail>
                                <br></br>
                                <BoxText ><p class="typo-14">• Cài đặt phân quyền</p></BoxText>
                                <BoxDetail >
                                    <p class="typo-14">Trong cài đặt kiểm soát truy cập của File A</p>
                                    <p class="typo-14">User A khi tạo file sẽ được cấp toàn bộ quyền truy cập thông qua Tag A (Files).</p>
                                    <p class="typo-14">Chọn User B để thiết lập Role là Editor.</p>
                                    <p class="typo-14">Chọn nhóm C để thiết lập Role là OnlyListingUser.</p>
                                    <p class="typo-14">Tag bao gồm: Dịch vụ / Loại tài nguyên / Chủ sở hữu (Service / Resource Type / Owner)</p>
                                </BoxDetail>
                            </SmallBox>

                            {/* {Imagecloudcompute("https://www.hanbiro.com/docs/cloud/images/c.png")} */}

                            {/*}
                            <BoxDetail >
                                사용자와 자원을 분리해 중간에 역활을 추가<br/>
                                사용자는 자주 바뀌지만 역활은 자주바뀌지 않음<br/>
                                서비스(Object)에 접속하는 Client(Subject)들은 미리 정의한<br/>
                                역활명으로 분류함 역활에 따라 자원(Object)의 Actions 권한을 할당<br/>
                                권한을 줄때 Role 단위로 줌<br/>
                                사용자는 할당된 역활에 기반하여 객체에 접근<br/>
                                역활은 직무에 따라서 정의<br/>
                                한유저는 여러 역활에 배정가능<br/>
                                여러유저는 한 역활에 배정가능
                            </BoxDetail>
                            {*/}
                        </BoxContent>
                        {/* <CloudConsultCp /> */}
                    </Col>
                </Row>
            </Container>

            <FooterVn />
        </Sysfont>
    );
};

const BoxSubText = styled.div`
  margin-left: 3%;
`

const BoxTitleIaam = styled.div`
  text-align: center;
  font-weight: bold;
  margin: 15px;
`

const CardTitle = {
    textAlign: "left",
    fontWeight: "bold",
    fontFamily: "맑은고딕, Dotum, 돋움, sans-serif !important;"
}

const TitleWrap = {
    height: "40px",
}

// const Box = styled.div`
//   @media only screen and (max-width: 767px){
//     font-size: 80%;
//   }
// `

const ImageWrap = styled.img`
  width: 100%;
  object-fit: fill;
`

const BoxContent = styled.div`
    ${'' /* box-shadow: 0 0.375rem 1.5rem rgb(140 152 164 / 13%);
    border: 1px solid #E7EAF3;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    margin-top: 20px; */}
    text-align: left;
`

const SmallBox = styled.div`
    ${'' /* border: 1px solid #E7EAF3;
    border-radius: 8px; */}
    margin-bottom: 20px;
    margin-top: 20px;
    text-align: left;
`

const BoxDetail = styled.div`
    margin: 10px 5px;
    line-height: 2em;
`

const BoxText = styled.div`
    margin: 5px;
    line-height: 2em;
`


export default IaamVN;